import { NavLink, useNavigate, useParams } from "react-router";
import { MasterDataPdfTable } from "@/services/backend/company/components/master-data-pdf-table";
import { MasterDataPdfCreateDialog } from "@/services/backend/company/components/master-data-pdf-create-dialog";

export function CompanyMasterDataPdfListRoute() {
  const { companyId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="grid gap-2">
      <div className="flex justify-end">
        <MasterDataPdfCreateDialog
          companyId={companyId!}
          onCreated={(id) => navigate(id)}
        />
      </div>
      <MasterDataPdfTable
        companyId={companyId!}
        renderRowLink={(id, children) => <NavLink to={id}>{children}</NavLink>}
      />
    </div>
  );
}
